var map = {
	".": [
		6705
	],
	"./": [
		6705
	],
	"./_schema": [
		5366
	],
	"./_schema.ts": [
		5366
	],
	"./culture": [
		4770
	],
	"./culture.ts": [
		4770
	],
	"./forms/addUpdate/FormaddUpdate": [
		2198
	],
	"./forms/addUpdate/FormaddUpdate.tsx": [
		2198
	],
	"./forms/addUpdate/_styles": [
		5282
	],
	"./forms/addUpdate/_styles.ts": [
		5282
	],
	"./index": [
		6705
	],
	"./index.tsx": [
		6705
	],
	"./styles_dark.css": [
		8468,
		468
	],
	"./styles_light.css": [
		3707,
		707
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5131;
module.exports = webpackAsyncContext;